import { render, staticRenderFns } from "./StudentIdentifierDirectMatch.vue?vue&type=template&id=19662df6&scoped=true&"
import script from "./StudentIdentifierDirectMatch.vue?vue&type=script&lang=js&"
export * from "./StudentIdentifierDirectMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19662df6",
  null
  
)

export default component.exports